import { Injectable } from '@angular/core';
import { ApplicationConfig } from '@frontend-site/shared/data';
import { catchError, EMPTY, map, Observable, switchMap, take, tap } from 'rxjs';
import { LocalStoreService } from '../local-store.service';
import { SessionRepository } from './session.repository';
import { SessionService } from './session.service';

@Injectable({ providedIn: 'root' })
export class SessionFacade {
    private currentLanguage?: string;

    constructor(
        private readonly store: SessionRepository,
        private readonly sessionService: SessionService,
        private readonly localStorage: LocalStoreService
    ) {}

    clear(): void {
        this.store.reset();
    }

    sessionInformation(): Observable<ApplicationConfig> {
        this.store.setLoading(true);

        return this.sessionService.getUsername().pipe(
            switchMap((username) => {
                const companyData = this.localStorage.getData<{ id: number; name: string }>(username + '.selectedCompany');

                return this.sessionService.getSessionInformation(companyData?.id).pipe(
                    map((session) => new ApplicationConfig(session)),
                    tap((config) => {
                        this.store.update({ config });
                        this.store.setLoading(false);

                        this.localStorage.saveData(username + '.selectedCompany', {
                            id: config.companyId,
                            name: config.companyName
                        });
                    }),
                    take(1),
                    catchError((err) => {
                        this.store.setError(err);
                        this.store.setLoading(false);

                        return EMPTY;
                    })
                );
            })
        );
    }

    setLegacyAppVersion(version: string): void {
        this.store.update({ legacyAppVersion: version });
    }

    loadSession(force = false): void {
        if (!force && this.store.applicationConfig) {
            return;
        }

        this.sessionInformation().subscribe();
    }
}
